<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding pay-dialog">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <h4 class="title">待支付的订单</h4>
          <div class="order-list">
            <div class="order"
              v-for="(order,index) in orderList"
                 :key="index"
            >
              <vs-checkbox v-model="order.selected">{{order.transactionId.slice(0,10)}}</vs-checkbox>
              <span>{{order.amount}}</span>
            </div>
          </div>
          <vs-divider/>
          <div class="line-box">
            <span class="text">订单合计</span>
            <span class="data pay-money">{{sumAmount}}</span>
          </div>
          <div class="line-box">
            <span class="text">可用余额</span>
            <span class="data banlice">{{total}}</span>
          </div>
          <vs-divider class="divider"/>
          <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认支付</vs-button>
          <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>

  import { queryWalletnfo } from '@/api/wallet'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
      name: "auditDialog",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        orderList:{
          type: Array,
          default(){
            return [];
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          total: ''
        }
      },
      created(){
        this.getTotal();
      },
      watch: {

      },
      computed: {
        title() {
          return '支付';
        },
        sumAmount(){
          let total = 0;
          for (let i = 0; i < this.orderList.length; i++) {
            total += this.orderList[i].realAmount;
          }
          return total;
        }
      },
      methods: {
        getTotal(){
          queryWalletnfo().then((res) => {
              this.total = res.data.primaryUsdt;
          })
        },
        close(){
          this.$emit('close')
        },
        reset(){
          this.form = {
            decision: 1,
            rejectReason: [],
            rejectReasonSelf: ''
          };
        },
        closeHandle() {
          this.close();

        },
        cancel(){
          this.close();
        },
        handleSelectIds(){
          let ids = [];
          for (let i = 0; i < this.orderList.length; i++) {
            if(this.orderList[i].selected){
              ids.push(this.orderList[i].transactionId);
            }
          }
          return ids;
        },
        submit(){
          this.$emit('send-ids', this.handleSelectIds());
        },

      },
    }
</script>

<style lang="scss">
  .pay-dialog {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .title {
      margin-top: 10px;
      font-size: 14px;
      font-weight: 700;
    }
    .order {
      margin-top: 20px;
    }
    .line-box,
    .order {
      display: flex;
      justify-content: space-between;
      color: #6E6B7B;
      align-items: center;
    }
    .line-box {
      margin-bottom: 10px;
    }
    .divider {
      margin-bottom: 20px;
    }
    .pay-money {
      color: #EA5455;
    }
    .banlice {
      font-weight: 600;
    }


  }


</style>
